import React from 'react'
import cn from 'classnames'
import { useCookiesContext } from 'contexts/CookiesContext'

import Wrapper from 'components/Wrapper/Wrapper'

import styles from './CardWithLargeVideo.module.css'

interface CardWithLargeVideoProps {
  videoComponent: () => React.ReactNode
  className?: string
  customChildrenStyles?: string
}

const CardWithLargeVideo: React.FC<CardWithLargeVideoProps> = ({
  videoComponent,
  children,
  className,
  customChildrenStyles,
}) => {
  const { areCookiesAccepted } = useCookiesContext()

  return (
    <Wrapper style={{ paddingLeft: 16, paddingRight: 16 }}>
      <div
        className={cn(
          styles.base,
          {
            [styles.withCookiesBanner]: !areCookiesAccepted,
            [styles.withoutCookiesBanner]: areCookiesAccepted,
          },
          className,
        )}
      >
        <aside className={styles.videoWrapper}>{videoComponent()}</aside>
        {children && (
          <div className={cn(styles.contentWrapper, customChildrenStyles)}>
            {children}
          </div>
        )}
      </div>
    </Wrapper>
  )
}

export default CardWithLargeVideo
